import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BackButton({ to, label = "Back" }) {
    const nav = useNavigate();
    return (
        <button
            onClick={() => (to ? nav(to) : nav(-1))}
            data-testid="back-button"
            className="inline-flex items-center gap-1.5 text-sm px-3 py-1.5 rounded-full border border-[rgba(26,19,24,0.12)] hover:bg-[rgba(255,107,53,0.08)] transition mb-4"
        >
            <ArrowLeft size={14} /> {label}
        </button>
    );
}
